import $ from 'jquery';
import './api/ajaxInterceptor'; 
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from "@react-oauth/google";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import SignalRContext from './context/SignalRContext';
import { WhatsAppMessageProvider } from './context/WhatsAppMessageContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const GMAIL_CLIENT_ID = process.env.REACT_APP_GMAIL_CLIENT_ID;

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="131980454946-clichraj8vgv6dmv6fnaitu94f8n0feh.apps.googleusercontent.com">
      <WhatsAppMessageProvider>
        <SignalRContext>
          <App />
        </SignalRContext>
      </WhatsAppMessageProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
